/* ============================================================
   Erenjoy — Wooden Roti Maker landing page
   Vanilla, dependency-free. Loaded with `defer`.
   Handles: gallery thumbnail switching, countdown timer,
   social-proof rotator, and proxying secondary CTAs to the
   Shiprocket headless checkout button.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Gallery: thumbnail -> main image swap ---------- */
  var gallery = document.querySelector('[data-roti-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-roti-main]');
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-roti-thumb]');
      if (!thumb || !mainImg) return;
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      /* The main image carries a srcset for the LCP; srcset wins over src,
         so we must drop it (and sizes) for the swapped image to show. */
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = full;
      if (thumb.getAttribute('alt')) mainImg.alt = thumb.getAttribute('alt');
      gallery.querySelectorAll('[data-roti-thumb]').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  }

  /* ---------- Countdown: resets at local midnight ----------
     Honest "today only" behaviour: the deadline is the end of the
     visitor's current day, so the timer is always genuine and never
     a fabricated perpetual loop. Updates every [data-roti-clock]. */
  var clocks = document.querySelectorAll('[data-roti-clock]');
  if (clocks.length) {
    var endOfToday = function () {
      var e = new Date();
      e.setHours(23, 59, 59, 0);
      return e;
    };
    var end = endOfToday();
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var diff = Math.floor((end - new Date()) / 1000);
      if (diff < 0) { end = endOfToday(); diff = Math.floor((end - new Date()) / 1000); }
      var t = pad(Math.floor(diff / 3600)) + ':' +
              pad(Math.floor((diff % 3600) / 60)) + ':' +
              pad(diff % 60);
      clocks.forEach(function (el) { el.textContent = t; });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Live social-proof rotator (opt-in) ----------
     Only runs when the section enabled it and supplied messages
     via data-roti-social (JSON array). Ship the toggle, not
     fabricated numbers. */
  var live = document.querySelector('[data-roti-social]');
  if (live) {
    var msgs = [];
    try { msgs = JSON.parse(live.getAttribute('data-roti-social')) || []; } catch (e) { msgs = []; }
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        i = (i + 1) % msgs.length;
        live.textContent = msgs[i];
      }, 3500);
    }
  }

  /* ---------- Secondary CTAs -> Shiprocket headless checkout ----------
     The real checkout button is injected by Shiprocket's SDK into
     #roti-sr-wrap. Every [data-roti-buy] button simply clicks it, so
     the variant/qty + checkout flow stay identical everywhere. */
  function triggerShiprocket() {
    var srBtn = document.querySelector(
      '#roti-sr-wrap .sr-headless-checkout, #roti-sr-wrap .shiprocket-headless button, #roti-sr-wrap button'
    );
    if (srBtn) { try { srBtn.click(); return; } catch (e) {} }
    /* Fallback: bring the real Shiprocket button into view. */
    var anchor = document.getElementById('roti-sr-wrap');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-roti-buy]');
    if (!btn) return;
    e.preventDefault();
    triggerShiprocket();
  });
})();
